class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);

document.addEventListener('click', async function(e) {
  const card = e.target.closest('.bl-cart-companion-checkbox-card') || e.target.closest('.bl-companion-add-btn');
  if (!card || card.classList.contains('is-loading')) return;
  card.classList.add('is-loading', 'is-adding');
  const checkbox = card.querySelector('input[type="checkbox"]');
  if (checkbox) checkbox.checked = true;

  const miniCart = document.querySelector('mini-cart');
  const sectionsToRender = miniCart ? miniCart.getSectionsToRender().map(s => s.id) : ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'];

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: 45812937097371, quantity: 1 }],
        sections: sectionsToRender,
        sections_url: window.location.pathname
      })
    });
    const data = await res.json();
    if (miniCart && data.sections) {
      miniCart.renderContents(data);
    }
    if (window.publish && window.PUB_SUB_EVENTS) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'mini-cart', productVariantId: 45812937097371 });
    }
  } catch (err) {
    console.error('Failed to add carrier bag:', err);
    card.classList.remove('is-loading', 'is-adding');
    if (checkbox) checkbox.checked = false;
  }
});
